export default __webpack_public_path__ + "static/media/reference_img02.4058a0e5.png";